import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import {
  isFromMarketingApplicationsRoute,
  isFromMarketingLeasesRoute,
  isFromMarketingPaymentsRoute,
} from '../../../utils/propertiesPageUtils';

import { useAuth } from '../../AuthProvider';
import Notifications, { type BannerToCloseArg } from '../Notifications';

export const PropertiesPageNotifications = () => {
  const router = useRouter();
  const { user } = useAuth();

  const [displayPaymentsNotification, setDisplayPaymentsNotification] = useState(false);
  const [displayApplicationsNotification, setDisplayApplicationsNotification] = useState(false);
  const [displayLeasesNotification, setDisplayLeasesNotification] = useState(false);
  const [displayListingClaimCompleteBanner, setDisplayListingClaimCompleteBanner] = useState(false);

  useEffect(() => {
    const query = router.query;

    const isFromMarketingPayments = isFromMarketingPaymentsRoute(query);
    const isFromMarketingLeases = isFromMarketingLeasesRoute(query);
    const isFromMarketingApplications = isFromMarketingApplicationsRoute(query);

    if (user?.restrictions?.isAllowed) {
      if (isFromMarketingPayments) {
        setDisplayPaymentsNotification(true);
      } else if (isFromMarketingLeases) {
        setDisplayLeasesNotification(true);
      } else if (isFromMarketingApplications && user.applicationsEnabled) {
        setDisplayApplicationsNotification(true);
      }
    }

    if (query.itc === 'listing_claim_complete') {
      setDisplayListingClaimCompleteBanner(true);
    }
  }, []);

  const handleBannerCloseClick = (bannerToClose: BannerToCloseArg) => {
    switch (bannerToClose) {
      case 'displayPaymentsNotification':
        setDisplayPaymentsNotification(false);
        break;
      case 'displayApplicationsNotification':
        setDisplayApplicationsNotification(false);
        break;
      case 'displayLeasesNotification':
        setDisplayLeasesNotification(false);
        break;
      case 'displayListingClaimCompleteBanner':
        setDisplayListingClaimCompleteBanner(false);
        break;
      default:
        break;
    }
  };

  return (
    <Notifications
      displayPaymentsNotification={displayPaymentsNotification}
      displayApplicationsNotification={displayApplicationsNotification}
      displayLeasesNotification={displayLeasesNotification}
      displayListingClaimCompleteBanner={displayListingClaimCompleteBanner}
      handleBannerCloseClick={handleBannerCloseClick}
    />
  );
};
